import LogoAnimation from '../../components/logoAnimation/LogoAnimation';
import PropTypes from 'prop-types';

function ScreenSaver(props) {
  const { theme } = props;
  document.onclick = () => {
    if (document.fullscreenElement) {
      document.exitFullscreen();
    } else {
      document.documentElement.requestFullscreen();
    }
  };
  return <LogoAnimation isScreenSaver={true} theme={theme}></LogoAnimation>;
}

ScreenSaver.propTypes = {
  theme: PropTypes.string,
};
export default ScreenSaver;
